<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchFor"
          label="Search"
          append-icon="search"
          :rules="[rules.search]"
          :hint="hints.search()"
          @change="search"
          @keyup.native.enter="search">
        </v-text-field>
      </v-card-title>

      <!-- list table -->
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="customers"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        v-if="state == 'list'"
        :footer-props="footerProps"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-xs-left">{{item.country}}</td>
            <td class="text-xs-left">{{item.customerId}}</td>
            <td class="text-xs-left">{{ item.concernName1 }}</td>
            <td class="text-xs-left">{{ item.concernName2 }}</td>
            <td class="text-xs-left">
              <activate-or-open-portal-btn
                :customerId="item.customerId"
                :contactCount="item.contactCount"
                :returnShopPortal="item.returnShopPortal"
              ></activate-or-open-portal-btn>
            </td>
            <td>
              <router-link :to="`/customers/${item.customerId}`">Edit</router-link>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!-- search table-->
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="customers"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        v-if="state == 'search'"
        :footer-props="footerProps"
        @update:items-per-page="getItemPerPage"
      >
        <template v:slot="headers" slot-scope="props">
          <th class="column text-xs-left" v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
        </template>
        <template v-slot:item="{ item }">
         <tr> 
          <td class="text-xs-left">{{item.country}}</td>
          <td class="text-xs-left" >{{ item.customerId}}</td>
          <td class="text-xs-left">{{ item.concernName1 }}</td>
          <td class="text-xs-left">{{ item.concernName2 }}</td>
          <td>
            <activate-or-open-portal-btn
              :customerId="item.customerId"
              :contactCount="item.contactCount"
              :returnShopPortal="item.returnShopPortal"
            ></activate-or-open-portal-btn>
          </td>
          <td>
            <router-link :to="`/customers/${item.customerId}`">Edit</router-link>
          </td>
         </tr> 
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style module>
  .searchHighlight {
    background-color: lightyellow;
  }
</style>

<script>
  import axios from 'axios';
  import DataService from '../services/data';

  import ActivateOrOpenPortalBtn from '../components/IsrsActiveOrOpenPortalBtn'

  export default {

    components: {
      ActivateOrOpenPortalBtn
    },

    data() {
      return {
        totalItems: 0,
        loading: true,
        pagination: {rowsPerPage:10, sortBy:'customerId'},
        footerProps: {
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageOptions: [10,20,40]
          },
        searchFor: '',
        state: 'list',
        headline: '',
        headers: [
          {text: "Country", value: "country", align: "left", sortable: false},
          {text: "Customer ID", value: "customerId", align: "left", sortable: false},
          {text: "Concern Name1", value: "concernName1", align: "left", sortable: false},
          {text: "Concern Name2", value: "concernName2", align: "left", sortable: false},
          {text: "Activation", align: "left", sortable: false},
          {text: "", align: "left", sortable: false}
        ],
        customers: [],
        error: "",
        valid: true,
        rules: {
          search: () => this.valid || "Suchbegriff muss mindestens 3 Zeichen lang sein"
        },
        hints: {
          search: () => {
            return this.searchFor.length === 0 || this.searchFor.length > 2 ? "" : "Suchbegriff muss mindestens 3 Zeichen lang sein"
          }
        }
      }
    },

    computed: {
/*       sortBy() {
        let {sortBy, descending} = this.pagination;

        if (descending) {
          sortBy = `${sortBy},desc`;
        }
        if (!sortBy) {
          sortBy = `Id`;
        }

        return sortBy
      } */
    },

    watch: {
      pagination: {
        handler: 'paginate',
        immediate: false
      }
    },

    created() {
      this.dataService = new DataService(this.profile, this.$store.state.tokens);
    },

    methods: {
    
    getItemPerPage(rows) {
      this.pagination.rowsPerPage = rows;
      this.paginate()
    },

      paginate() {

        if (this.searchFor) {

          return this.search(
            this.pagination.rowsPerPage,
            this.pagination.page,
            this.sortBy
          );
        }

        return this.fetchCustomers(
          this.pagination.rowsPerPage,
          this.pagination.page,
          this.sortBy
        );
      },

      fetchCustomers(size = 5, page = 1, sort = "customerId", descending = false) {
        this.loading = true;
        this.state = 'list';

/*         if (descending) {
          sort = `${sort},desc`;
        } */

        return this.dataService.getCustomers(page, size, sort)
          .then(this.updateDataTable)
          .catch(err => {
              this.error = err;
              this.loading = false;
            }
          );
      },


      search(size = 10, page = 0) {
        if (this.searchFor) {
          if (this.searchFor.length < 3) {
            this.valid = false;
            return false;
          }
          this.valid = true;

          this.state = 'search';
          this.loading = true;

          if (this.searchFor.match(/^\d+$/)) {
            this.headline = `Suche Kundennummer: ${this.searchFor}`;

            this.dataService.getCustomer(this.searchFor)
              .then(result => {
                return {
                  data: {
                    content: [result.data],
                    totalElements: 1
                  }
                }
              })
              .then(this.updateDataTable)
              .catch(err => {
                this.error = err;
                this.loading = false;
              });
          } else {
            this.headline = `Suche Name: ${this.searchFor}`;

            this.dataService.searchCustomers(this.searchFor, this.pagination.rowsPerPage, this.pagination.page)
              .then(this.updateDataTable)
              .catch(err => {
                this.error = err;
                this.loading = false;
              });
          }

        } else {
          this.resetSearch();
        }
      },
      resetSearch() {
        this.searchFor = "";
        this.state = 'list';
        this.headline = '';
        this.valid = true;
        this.paginate();
      },
      updateDataTable(result) {
        this.customers = result.data.content;
        this.totalItems = result.data.totalElements;
        this.loading = false;
        return result;
      },
      getTooltip(contactCount, returnShopPortal) {
        if (contactCount === 0) {
          return 'Freischaltung nicht möglich';
        } else if (returnShopPortal) {
          return 'Öffnen';
        }
        return 'Freischalten';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Customers.vue?b5b3fa06